import type { ApiUserResponseType } from "@/types/entities/users";
import axios from "@/utils/axios";
import { useInfiniteQuery } from "@tanstack/react-query";

export type UsersFiltersProps = {
  page?: number;
  per_page?: number;
  search?: string;
  sort_by?: string;
  role?: string;
  withoutRole?: boolean;
  sort_direction?: "asc" | "desc";
  relationships?: string[];
  processes?: string;
  created_by?: string;
  group_by?: string;
  status?: string;
  created_at?: string;
};

export const useGetApplicantsAsInfinite = (
  filters: UsersFiltersProps,
  enabled = true,
) => {
  const queryParams = {
    per_page: filters.per_page || 10,
    filter: {
      ...(filters.search && {
        search: filters.search,
      }),
    },
  };
  return useInfiniteQuery({
    queryKey: ["users-infinite", queryParams],
    queryFn: async ({ pageParam = 1 }): Promise<ApiUserResponseType> => {
      const response = await axios.get("/admin/v1/applicant", {
        params: {
          page: pageParam,
          ...queryParams,
          relationships: filters.relationships
            ? filters.relationships.join(",")
            : undefined,
        },
      });
      return response.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { current_page, last_page } = (lastPage as ApiUserResponseType)
        .meta;
      if (current_page < last_page) {
        return current_page + 1;
      }
    },
    enabled,
  });
};
